function a(e) {
  const r = JSON.stringify(e);
  return Buffer.from(r).toString("base64").replace("+", "-").replace("/", "_").replace(/=+$/, "");
}
export {
  a as default
};
